module.exports = __webpack_public_path__ + "static/media/537.6ffca59e.png";